<rn-account-status-warning context="notification"/>
<div class="catalog-home">
  <div class="catalog-home-banner hide-xs">
    <div class="mat-headline-2 catalog-home-title">
      Explore our<br/>
      collection
    </div>
    <h1 class="catalog-home-subtitle">
      Search, browse and place items on<br/>
      hold with our library catalog.
    </h1>
  </div>
  <div class="catalog-mobile-header mat-headline-4 hide-gt-xs">
    Catalog
  </div>
  <div class="search-bar">
    <div class="search-center flex-row" [formGroup]="searchForm">
      <mat-select formControlName="searchTarget">
        <mat-option value="KEYWORD" selected>Keyword</mat-option>
        <mat-option value="TITLE">Title</mat-option>
        <mat-option value="AUTHOR">Author</mat-option>
        <mat-option value="ISBN">ISBN</mat-option>
        <mat-option value="SERIES">Series</mat-option>
      </mat-select>
      <input (keydown.enter)="doSearch()" formControlName="searchTerm" placeholder="Search term"/>
      <button (click)="doSearch()">
        <img alt="magnifying glass" src="/assets/magnifying-glass.svg"/>
      </button>
    </div>
  </div>
  @if (loading$ | async) {
    <div class="spinner-container">
      <mat-spinner/>
    </div>
  } @else {
    <div>
      <div class="carousel-container">
        @for (carousel of carouselDisplays; track carousel.id) {
          <rn-book-carousel [catalogRecords]="carousel.catalogRecords" [title]="carousel.title"/>
          @if (!$last) {
            <hr class="catalog-hr"/>
          }
        }
      </div>
    </div>
    <rn-catalog-footer/>
  }
</div>
